// ────────────────────────────────────────────────────────────────────
// DockPill — the minimized representation of a dock window: a compact
// bar the user clicks to restore. Same chrome family as DockWindow
// (panel/ink/brand tokens, mono uppercase), not a rounded chat-head.
// ────────────────────────────────────────────────────────────────────
import type { ReactNode } from "react";

export interface DockPillProps {
  id: string;
  title: string;
  icon?: ReactNode;
  unread?: boolean;
  onRestore: (id: string) => void;
}

export function DockPill({ id, title, icon, unread, onRestore }: DockPillProps): JSX.Element {
  return (
    <button
      type="button"
      onClick={() => onRestore(id)}
      aria-label={`${title} (ขยาย)`}
      title={title}
      className="relative flex items-center gap-1.5 px-2.5 h-8 bg-panel-850 border border-panel-700 hover:border-brand text-ink-2 hover:text-brand font-mono text-[10px] uppercase tracking-wider shadow-raised transition-colors"
    >
      {icon}
      <span className="max-w-[110px] truncate">{title}</span>
      {unread && (
        <span
          aria-hidden="true"
          data-testid="dock-pill-unread"
          className="absolute -top-1 -right-1 w-2 h-2 rounded-full bg-accent"
        />
      )}
    </button>
  );
}
